import type { Profession } from '@/types/onboarding';

/** Icelandic profession names, shared by onboarding and the conversation speaker titles. */
export const PROFESSION_LABELS: Record<Profession, string> = {
  doctor: 'Læknir',
  nurse: 'Hjúkrunarfræðingur',
  physiotherapist: 'Sjúkraþjálfari',
  psychologist: 'Sálfræðingur',
  midwife: 'Ljósmóðir',
  occupational_therapist: 'Iðjuþjálfi',
  speech_therapist: 'Talmeinafræðingur',
  dietitian: 'Næringarfræðingur',
  social_worker: 'Félagsráðgjafi',
  other: 'Annað',
};
